import { trimFieldString, search_asp } from "../util.js";

export function translateRemoveMarkLabel(tech, args, line, parsed, source, mapping, processed, config) {
  let rules = [];
  let text_map = mapping[args[1]];
  let layer_map = mapping[args[0]];
  let layer = source.layer[layer_map.layer];
  let rule = {
    category: "recommender",
    description: `Remove mark label for ${source.layer[text_map.layer].text[text_map.text].field}`,
    specifier: {
      role: "mark.label",
      field: source.layer[text_map.layer].text[text_map.text].field
    },
    action: "remove"
  };
  if (layer.name) rule.specifier.layer = { id: layer.name };
  else rule.specifier.layer = { index: mapping[args[0]]?.layer };
  if (text_map) {
    rule.specifier.id = layer.text[text_map.text].name;
  }
  rules.push(rule);
  return rules;
}

export function translateAddMarkLabel(tech, args, line, parsed, source, mapping, processed, config) {
  let rules = [];
  // do(add_mark_label,L,F)
  let layer = source.layer?.[mapping[args[0]]?.layer];
  let field = trimFieldString(args[1]);
  if (layer) {
    let rule = {
      category: "recommender",
      description: `Add mark label for ${field}`,
      specifier: {
        role: "layer",
      },
      action: "add",
      option: {
        role: "text",
        text: {
          field,
          type: "mark",
          items: [{}],
          dx: 5,
          dy: -5,
          anchor: "start",
          orient: "middle-center",
          width: 80
        }
      }
    }
    if (layer.name) rule.specifier.id = layer.name;
    else rule.specifier.index = mapping[args[0]]?.layer;
    rules.push(rule);
  }
  return rules;
}
export function translateReplaceMarkLabel2AxisLabel(tech, args, line, parsed, source, mapping, processed, config) {
  // replace_mark_label_to_axis_label,l0,"justice")
  let rules = [];
  let layer = source.layer[mapping[args[0]].layer], field = trimFieldString(args[1]);
  let rel_text = layer.text.filter(text => text.type === "on-mark" && text.field === field);

  rules.push({
    category: "recommender",
    description: `Remove mark label for ${field}`,
    specifier: { role: "mark.label", mark: layer.mark.type, field: field },
    action: "remove"
  });
  let rule_ax = {
    category: "recommender",
    description: `Add axis label for ${field}`,
    specifier: { role: "layer", mark: layer.mark.type },
    action: "add",
    option: {
      text: {
        type: "axis",
        field: field,
        items: [{}]
      }
    }
  };
  let values = [];
  rel_text.forEach(text => { if (text.values) values.push(...text.values) });
  if (values) {
    rule_ax.option.text.values = values;
  }
  let text_org = rel_text[0]
  if (text_org) {
    if (text_org.items[0].fontWeight) rule_ax.option.text.fontWeight = text_org.items[0].fontWeight;
    if (text_org.items[0].fontSize) rule_ax.option.text.fontSize = text_org.items[0].fontSize;
    if (text_org.items[0].width) rule_ax.option.text.width = text_org.items[0].width;
    if (text_org.items[0].fontColor) rule_ax.option.text.fontColor = text_org.items[0].fontColor;
    if (text_org.items[0].expression) rule_ax.option.text.items[0].expression = text_org.items[0].expression;
  }
  rules.push(rule_ax);
  return rules;
}

export function translateExternalizeMarkLabel(tech, args, line, parsed, source, mapping, processed, config) {
  // do(externalize_mark_label,L) // do(externalize_mark_label,L,T)
  let rules = [];
  let layer_map = mapping[args[0]];
  let layer = source.layer[layer_map.layer];
  let rule = {
    category: "recommender",
    description: `Externalize mark label for ${layer.name}`,
    specifier: {
      role: "mark.label",
    },
    action: "modify",
    option: {
      external: true,
      items: { textAlign: "left" }
    }
  };
  if (layer.name) rule.specifier.layer = { id: layer.name };
  else if (layer.mark?.type) rule.specifier.layer = { mark: layer.mark?.type };

  let p;
  if ((p = search_asp(parsed, `do(number_mark_label_adj,${args[0]}`, "startsWith")?.[0], p)) {
    rule.option.numbering = true;
    // 0,0 to signal the originating position;
    rule.option.dx = 0;
    rule.option.dy = 0;
    rule.option.x = null;
    rule.option.y = null;
    rule.option.orient = "middle-center";
    rule.option.anchor = "center";
    rule.option.tick = null;
    rule.option.width = null;
    rule.option.items = { textAlign: "left" };
  }
  let p2;
  if ((p2 = search_asp(parsed, `do(flatten_mark_label_lines,${args[0]}`, "startsWith")?.[0], p2)) {
    rule.option.flatten = true;
  }
  rules.push(rule);
  return rules;
}

export function translateNumberMarkLabel(tech, args, line, parsed, source, mapping, processed, config) {
  // do(number_mark_label,L,T)
  let rules = [];
  let layer_map = mapping[args[0]];
  let layer = source.layer[layer_map.layer];

  let rule = {
    category: "recommender",
    description: `Externalize mark label for ${layer.name || ""}`,
    specifier: {
      role: "mark.label"
    },
    action: "modify",
    option: {
      external: true,
      numbering: true,
      dx: 5,
      dy: 0,
      x: null,
      y: null,
      orient: "middle-center",
      anchor: "center",
      tick: null,
      textAlign: "left",
      width: null
    }
  };
  if (layer.name) rule.specifier.layer = { id: layer.name };
  else if (layer.mark?.type) rule.specifier.layer = { mark: layer.mark?.type };

  rules.push(rule);
  return rules;
}